import { ActionTypes } from '../constants/index';

export const getNotificationManagement = (payload: any) => ({
  type: ActionTypes.NOTIFICATION_MGMT_LIST_REQUEST,
  payload,
});
